import { render, staticRenderFns } from "./DisclaimerModal.vue?vue&type=template&id=6822e88f&scoped=true&"
import script from "./DisclaimerModal.vue?vue&type=script&lang=ts&"
export * from "./DisclaimerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822e88f",
  null
  
)

export default component.exports